import { render, staticRenderFns } from "./configContentOrder.vue?vue&type=template&id=98cae5e2&scoped=true"
import script from "./configContentOrder.vue?vue&type=script&lang=js"
export * from "./configContentOrder.vue?vue&type=script&lang=js"
import style0 from "./configContentOrder.vue?vue&type=style&index=0&id=98cae5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cae5e2",
  null
  
)

export default component.exports